import { useMemo } from "react";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/content";
import HeroSection from "@/pages/home/components/HeroSection";
import FocusSection from "@/pages/home/components/FocusSection";
import EventsExplorer from "@/pages/home/components/EventsExplorer";
import WeeklyPreview from "@/pages/home/components/WeeklyPreview";
import CategorySection from "@/pages/home/components/CategorySection";
import FaqAccordion from "@/pages/home/components/FaqAccordion";
import BrandSection from "@/pages/home/components/BrandSection";
import SubscribeCta from "@/pages/home/components/SubscribeCta";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "1每日吃瓜",
        url: "https://77di.cn/",
        description:
          "聚焦每日吃瓜热门事件与大瓜汇总的中文内容门户，提供本周瓜单与焦点事件脉络梳理。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target:
            "https://77di.cn/events?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "1每日吃瓜本周瓜单",
        itemListElement: [
          "summer-drama-comeback",
          "variety-show-golden-cut",
          "music-festival-lineup",
          "box-office-dark-horse",
          "celebrity-wedding-look",
        ].map((slug, idx) => ({
          "@type": "ListItem",
          position: idx + 1,
          url: `https://77di.cn/events/${slug}`,
        })),
      },
    ],
    [],
  );

  useSeo({
    title: "1每日吃瓜 | 每日吃瓜热门事件与大瓜汇总一站掌握",
    description:
      "1每日吃瓜聚焦每日吃瓜热门事件与1每日吃瓜大瓜汇总，提供本周瓜单、焦点事件脉络梳理与热门事件深度盘点，帮你几分钟看清事件来龙去脉。",
    keywords:
      "1每日吃瓜,1每日吃瓜热门事件,1每日吃瓜大瓜汇总,1每日吃瓜本周瓜单,1每日吃瓜焦点事件",
    path: "/",
    jsonLd,
  });

  return (
    <SiteLayout>
      <HeroSection />
      <FocusSection />
      <EventsExplorer />
      <WeeklyPreview />
      <CategorySection />
      <FaqAccordion />
      <BrandSection />
      <SubscribeCta />
    </SiteLayout>
  );
}